

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/vendorMaster/ON_CALL_UPLOAD';
export const ON_SUBMIT_TRUE = 'boilerplate/vendorMaster/ON_SUBMIT_TRUE';
export const SET_PROCESS_COUNT = 'boilerplate/vendorMaster/SET_PROCESS_COUNT';
export const SET_ERR_COUNT = 'boilderplate/vendorMaster/SET_ERR_COUNT';
export const LOADER_STATUS = 'boilderplate/vendorMaster/LOADER_STATUS';
export const PROFILE_INFO = 'boilerplate/vendorMaster/PROFILE_INFO';
export const SUPPLIER_INFO = 'boilerplate/vendorMaster/SUPPLIER_INFO';
export const SET_TOTAL_RECORD = 'boilerplate/vendorMaster/SET_TOTAL_RECORD';
export const ON_PROGRESS_DATA = 'boilderplate/vendorMaster/ON_PROGRESS_DATA'
export const SET_TABLE_DATA = 'vendorMaster/SET_TABLE_DATA';

export const ON_NOTIFY = 'boilerplate/vendorMaster/ON_NOTIFY'
